import { render, staticRenderFns } from "./FlowReport.vue?vue&type=template&id=467a219c&scoped=true&"
import script from "./FlowReport.vue?vue&type=script&lang=js&"
export * from "./FlowReport.vue?vue&type=script&lang=js&"
import style0 from "./FlowReport.vue?vue&type=style&index=0&id=467a219c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467a219c",
  null
  
)

export default component.exports